// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__qBmAd","header":"styles_header__iTG+G"};